import React, {useContext, useState, useEffect, useRef} from 'react';
import _ from "lodash";
import "./financeReport.scss"
import {useHistory, withRouter} from "react-router-dom";
import {Formik, Form, Field, FieldArray} from "formik";
import { StoreContext } from '../../store/context'
import Paper from '@material-ui/core/Paper';
import { DatePicker } from "@material-ui/pickers";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FixedHeaderTable from '../../components/FixedHeaderTable';
import moment from 'moment';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {PAYMENT_HISTORY_TEACHER, PAYMENT_HISTORY_STUDENT} from "../../utils/constants";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import * as yup from 'yup';
const useStyles = makeStyles({
    table: {
        minWidth: 450,
    },
});


const columns = [
    {
        id: 'studentName',
        label: 'Student Name',
        minWidth: 170
    },
    {
        id: 'courses',
        label: 'Courses',
        minWidth: 170,
        align: 'right',
    },
    {
        id: 'miscs',
        label: 'Miscs',
        minWidth: 170,
        align: 'right',
    },
    {
        id: 'transactionType',
        label: 'Transaction Type',
        minWidth: 170,
        align: 'right',
    },
    {
        id: 'transactionDate',
        label: 'Transaction Date',
        minWidth: 170,
        align: 'right',
    },
    {
        id: 'totalAmount',
        label: 'Total(RM)',
        minWidth: 170,
        align: 'right',
    }
];

const FinanceReport = () => {
    const classes = useStyles();
    const history = useHistory();
    const { state, actions } = useContext(StoreContext); // get global state and dispatch function
    const { getAllMisc, getAllStudents, getAllTeachers } = actions.generalActions;
    const { showStudentDetailDialog, getStudentsFinanceReport } = actions.paymentActions;
    const { studentsFinanceReport } = state.paymentStates;
    const { studentDetailDialogVisible } = state.paymentStates;
    const { students, teachers } = state.generalStates;
    const [programLvl, setProgramLvl] = React.useState(null);
    const [type, setType] = React.useState(PAYMENT_HISTORY_STUDENT);
    const [selectedDate, handleDateChange] = useState(null);

    useEffect(() => {
        // getAllMisc();
        // getAllStudents();
    }, []);

    const handleChange = (event) => {
        setProgramLvl(event.target.value);
    };

    const handleSearchButton = () => {
        if (selectedDate == null) {
            return;
        }
        if (programLvl == null) {
            return;
        }

        const month = moment(selectedDate).format('MM-YYYY');
        getStudentsFinanceReport(month, programLvl);
        // getAllStudents(studentName, programLvl);
    };

    const getTotalAmount = () => {
        let totalAmount = 0;
        for (let i=0; i < studentsFinanceReport.length; i ++) {
            totalAmount += studentsFinanceReport[i].totalAmount;
        }
        return `${parseFloat(totalAmount).toFixed(2)}`;
    }

    return (
        <div className="misc-student-payment-container">
            <h1 className="header">Finance Report</h1>
            <div className="paperContainer">
                <FormControl className="form-control">
                    <DatePicker
                        style={{marginTop: "0px"}}
                        className="date-picker"
                        views={["year", "month"]}
                        label="Date"
                        value={selectedDate}
                        onChange={handleDateChange}
                    />
                </FormControl>
                <FormControl className="form-control">
                    <InputLabel id="program-lvl-label">Program level</InputLabel>
                    <Select
                        labelId="program-lvl-label"
                        value={programLvl}
                        onChange={handleChange}>
                        <MenuItem value={1}>Remove</MenuItem>
                        <MenuItem value={2}>Form 1</MenuItem>
                        <MenuItem value={3}>Form 2</MenuItem>
                        <MenuItem value={4}>Form 3</MenuItem>
                        <MenuItem value={5}>Form 4</MenuItem>
                        <MenuItem value={6}>Form 5</MenuItem>
                        <MenuItem value={8}>Form 5 (Graduated)</MenuItem>
                    </Select>
                </FormControl>

                <Button className="search-btn" variant="contained" color="primary" onClick={handleSearchButton}>
                    Search
                </Button>

                <div className="table-container">
                    {<FixedHeaderTable columns={columns} rows={studentsFinanceReport} totalAmount={getTotalAmount()}/>}
                </div>

            </div>

        </div>
    )
}

export default withRouter(FinanceReport)
